import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";
import { QueuedProcess } from "../models/ProcessQueue";

@Injectable({ providedIn: "root" })
export class ProcessQueueService {
	constructor(private http: HttpClient) {}

	get(emisorId: string): Observable<QueuedProcess[]> {
		return this.http.get<QueuedProcess[]>(`${environment.backend_server}/company/${emisorId}/queued-processes`);
	}

	retry(emisorId: string, processId: string): Observable<void> {
		return this.http.post<void>(
			`${environment.backend_server}/company/${emisorId}/queued-processes/${processId}/retry`,
			null
		);
	}
}
